import { render } from "./daysgroupsBasicComponentAdd.vue?vue&type=template&id=4c4cd2ae&scoped=true"
import script from "./daysgroupsBasicComponentAdd.vue?vue&type=script&lang=js"
export * from "./daysgroupsBasicComponentAdd.vue?vue&type=script&lang=js"

import "./daysgroupsBasicComponentAdd.vue?vue&type=style&index=0&id=4c4cd2ae&scoped=true&lang=css"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4cd2ae"]])

export default __exports__